import { Network } from '@gobob/sats-wagmi';
export const DEFAULT_TIMEOUT_SECONDS = 5000;
// export const DEFAULT_NETWORK =
//   process.env.REACT_APP_BTC_NETWORK === 'testnet'
//     ? Network.testnet
//     : Network.mainnet;
// export const API_BASE_BTC_URL =
//   process.env.REACT_APP_BTC_NETWORK === 'testnet'
//     ? 'https://blockstream.info/testnet/api'
//     : 'https://blockstream.info/api';
export const DEFAULT_NETWORK = Network.testnet;
export const API_BASE_BTC_URL = 'https://blockstream.info/testnet/api';
export const USD = 'USD';
export const BITCOIN = 'BTC';
export const BTC_RENDER_PRECISION = 8;
export const BITCOIN_WALLETS_URL = 'https://bitcoin.org/en/choose-your-wallet';
export const BITCOIN_FAUCET_URL = 'https://coinfaucet.eu/en/btc-testnet/';
export const SOCIAL_LINKS = {
    DISCORD: 'https://discord.com/invite/bitcoinos',
    TELEGRAM: 'https://t.me/BitcoinOS_Build',
    TWITTER: 'https://x.com/BTC_OS',
    GITHUB: 'https://github.com/bitsnark/bitsnark-lib',
};
export const BOS_LINKS = {
    BITCOINOS: 'https://www.bitcoinos.build/',
    WHITEPAPER: 'https://assets-global.website-files.com/661e3b1622f7c56970b07a4c/662a7a89ce097389c876db57_BitSNARK__Grail.pdf',
    ROADMAP: 'https://www.bitcoinos.build/blog/bitcoinos-technical-infrastructure-and-roadmap',
    BOS_PRESALE: 'https://www.bitcoinos.build/bos-presale',
};
